import { ProviderBuilder, EGenMode } from '@educraft/base';
import * as UnitConversion from './generators/mathUnitConversion';

export function registerGenUnit(builder: ProviderBuilder): void {
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Delka__1Q,
    'Single.PrevodJednotek__Delka__1Q'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Delka__NQ,
    'Single.PrevodJednotek__Delka__NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Delka__N_NQ,
    'Single.PrevodJednotek__Delka__N_NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Plocha__1Q,
    'Single.PrevodJednotek__Plocha__1Q'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Plocha__NQ,
    'Single.PrevodJednotek__Plocha__NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Plocha__N_NQ,
    'Single.PrevodJednotek__Plocha__N_NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Objem__1Q,
    'Single.PrevodJednotek__Objem__1Q'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Objem__NQ,
    'Single.PrevodJednotek__Objem__NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Objem__N_NQ,
    'Single.PrevodJednotek__Objem__N_NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Hmotnost__1Q,
    'Single.PrevodJednotek__Hmotnost__1Q'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Hmotnost__NQ,
    'Single.PrevodJednotek__Hmotnost__NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Hmotnost__N_NQ,
    'Single.PrevodJednotek__Hmotnost__N_NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__DelkaUS__1,
    'Single.PrevodJednotek__DelkaUS__1'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__DelkaUS__N,
    'Single.PrevodJednotek__DelkaUS__N'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__DelkaUS__N_N,
    'Single.PrevodJednotek__DelkaUS__N_N'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__DelkaUS__1Q,
    'Single.PrevodJednotek__DelkaUS__1Q'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__DelkaUS__NQ,
    'Single.PrevodJednotek__DelkaUS__NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__DelkaUS__N_NQ,
    'Single.PrevodJednotek__DelkaUS__N_NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__ObjemUS__1,
    'Single.PrevodJednotek__ObjemUS__1'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__ObjemUS__N,
    'Single.PrevodJednotek__ObjemUS__N'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__ObjemUS__N_N,
    'Single.PrevodJednotek__ObjemUS__N_N'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__ObjemUS__1Q,
    'Single.PrevodJednotek__ObjemUS__1Q'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__ObjemUS__NQ,
    'Single.PrevodJednotek__ObjemUS__NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__ObjemUS__N_NQ,
    'Single.PrevodJednotek__ObjemUS__N_NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__HmotnostUS__1,
    'Single.PrevodJednotek__HmotnostUS__1'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__HmotnostUS__N,
    'Single.PrevodJednotek__HmotnostUS__N'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__HmotnostUS__N_N,
    'Single.PrevodJednotek__HmotnostUS__N_N'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__HmotnostUS__1Q,
    'Single.PrevodJednotek__HmotnostUS__1Q'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__HmotnostUS__NQ,
    'Single.PrevodJednotek__HmotnostUS__NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__HmotnostUS__N_NQ,
    'Single.PrevodJednotek__HmotnostUS__N_NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Cas__1,
    'Single.PrevodJednotek__Cas__1'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Cas__N,
    'Single.PrevodJednotek__Cas__N'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Cas__N_N,
    'Single.PrevodJednotek__Cas__N_N'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Cas__1Q,
    'Single.PrevodJednotek__Cas__1Q'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Cas__NQ,
    'Single.PrevodJednotek__Cas__NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Cas__N_NQ,
    'Single.PrevodJednotek__Cas__N_NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Sila__1Q,
    'Single.PrevodJednotek__Sila__1Q'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Sila__NQ,
    'Single.PrevodJednotek__Sila__NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Sila__N_NQ,
    'Single.PrevodJednotek__Sila__N_NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Energie__1Q,
    'Single.PrevodJednotek__Energie__1Q'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Energie__NQ,
    'Single.PrevodJednotek__Energie__NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Energie__N_NQ,
    'Single.PrevodJednotek__Energie__N_NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Vykon__1Q,
    'Single.PrevodJednotek__Vykon__1Q'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Vykon__NQ,
    'Single.PrevodJednotek__Vykon__NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Vykon__N_NQ,
    'Single.PrevodJednotek__Vykon__N_NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Tlak__1Q,
    'Single.PrevodJednotek__Tlak__1Q'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Tlak__NQ,
    'Single.PrevodJednotek__Tlak__NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Tlak__N_NQ,
    'Single.PrevodJednotek__Tlak__N_NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Napeti__1Q,
    'Single.PrevodJednotek__Napeti__1Q'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Napeti__NQ,
    'Single.PrevodJednotek__Napeti__NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Napeti__N_NQ,
    'Single.PrevodJednotek__Napeti__N_NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Proud__1Q,
    'Single.PrevodJednotek__Proud__1Q'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Proud__NQ,
    'Single.PrevodJednotek__Proud__NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Proud__N_NQ,
    'Single.PrevodJednotek__Proud__N_NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Odpor__1Q,
    'Single.PrevodJednotek__Odpor__1Q'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Odpor__NQ,
    'Single.PrevodJednotek__Odpor__NQ'
  );
  builder.add(
    EGenMode.GenSingle,
    (UnitConversion as any).PrevodJednotek__Odpor__N_NQ,
    'Single.PrevodJednotek__Odpor__N_NQ'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Delka__1,
    'Multi.PrevodJednotek__Delka__1'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Delka__N,
    'Multi.PrevodJednotek__Delka__N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Delka__N_N,
    'Multi.PrevodJednotek__Delka__N_N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Plocha__1,
    'Multi.PrevodJednotek__Plocha__1'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Plocha__N,
    'Multi.PrevodJednotek__Plocha__N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Plocha__N_N,
    'Multi.PrevodJednotek__Plocha__N_N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Objem__1,
    'Multi.PrevodJednotek__Objem__1'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Objem__N,
    'Multi.PrevodJednotek__Objem__N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Objem__N_N,
    'Multi.PrevodJednotek__Objem__N_N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Hmotnost__1,
    'Multi.PrevodJednotek__Hmotnost__1'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Hmotnost__N,
    'Multi.PrevodJednotek__Hmotnost__N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Hmotnost__N_N,
    'Multi.PrevodJednotek__Hmotnost__N_N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Sila__1,
    'Multi.PrevodJednotek__Sila__1'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Sila__N,
    'Multi.PrevodJednotek__Sila__N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Sila__N_N,
    'Multi.PrevodJednotek__Sila__N_N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Energie__1,
    'Multi.PrevodJednotek__Energie__1'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Energie__N,
    'Multi.PrevodJednotek__Energie__N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Energie__N_N,
    'Multi.PrevodJednotek__Energie__N_N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Vykon__1,
    'Multi.PrevodJednotek__Vykon__1'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Vykon__N,
    'Multi.PrevodJednotek__Vykon__N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Vykon__N_N,
    'Multi.PrevodJednotek__Vykon__N_N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Tlak__1,
    'Multi.PrevodJednotek__Tlak__1'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Tlak__N,
    'Multi.PrevodJednotek__Tlak__N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Tlak__N_N,
    'Multi.PrevodJednotek__Tlak__N_N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Napeti__1,
    'Multi.PrevodJednotek__Napeti__1'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Napeti__N,
    'Multi.PrevodJednotek__Napeti__N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Napeti__N_N,
    'Multi.PrevodJednotek__Napeti__N_N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Proud__1,
    'Multi.PrevodJednotek__Proud__1'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Proud__N,
    'Multi.PrevodJednotek__Proud__N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Proud__N_N,
    'Multi.PrevodJednotek__Proud__N_N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Odpor__1,
    'Multi.PrevodJednotek__Odpor__1'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Odpor__N,
    'Multi.PrevodJednotek__Odpor__N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Odpor__N_N,
    'Multi.PrevodJednotek__Odpor__N_N'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Stupne,
    'Multi.PrevodJednotek__Stupne'
  );
  builder.add(
    EGenMode.GenMulti,
    (UnitConversion as any).PrevodJednotek__Teplota_C_F,
    'Multi.PrevodJednotek__Teplota_C_F'
  );
}
